<template>
  <v-theme-provider dark>
    <base-section id="contact-us" class="green accent-4" space="40">
      <v-container>
        <v-row justify="center">
          <v-col cols="10">
            <base-title
              :space="$vuetify.breakpoint.mdAndUp ? 0 : 4"
              title="HAVE QUESTIONS? LET US KNOW!"
            />

            <base-body space="0">
              <span class="white--text">
                Have questions on your accounting, corporate secretarial and
                corporate and income tax matters? Book and receive a free
                consultation session with us today! Let us hear you and be your
                solutions in every of your accounting, corporate secretarial and
                income tax matters.
              </span>
            </base-body>
          </v-col>

          <v-col cols="12" md="2">
            <base-btn
              :block="$vuetify.breakpoint.smAndDown"
              color="white"
              href="/contact-us"
              large
              outlined
              target="_blank"
            >
              Contact Us
            </base-btn>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionContactUs"
};
</script>

<style scoped>
.v-application .green.accent-4 {
  background-color: #0aa24b !important;
  border-color: #0aa24b !important;
}
</style>
